export interface MapContainerStyle {
    width: string;
    height: string;
  }
  
  export interface MapOptions {
    disableDefaultUI: boolean;
    zoomControl: boolean;
  }
  
  export interface LandmarkLocation {
    lat: number;
    lng: number;
  }
  
  export const mapContainerStyle: MapContainerStyle = {
   
    width: '19vw',
    height: '45vh',

  };
  
  export const options: MapOptions = {
    disableDefaultUI: true,
    zoomControl: true,
  };
  
  export const landmarkLocation: LandmarkLocation = {
    lat: 37.7749, // Latitude of the landmark (San Francisco)
    lng: -122.4194 // Longitude of the landmark (San Francisco)
  };
  